// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Criteria = t.struct({
    historyToDisplay: t.maybe(t.Number)
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        historyToDisplay: 90
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/state/criteria.js